<div class="container">
    <h1 class="principal-title-pub">Catálogo de Publicaciones</h1>
    <ng-container *ngIf="pub">
        <div class="pt-3">
            <small>Disponible en </small> <small class="language text-green-pub">ESPAÑOL</small>
        </div>
        <h1 class="principal-title">{{pub.name}}</h1>

        <div class="row">
            <div class="col-md-8">
                <div class="text-green-pub pb-2">{{pub.year}} | {{pub.name | uppercase}}</div>
                <div class="pub-container">
                    <div class="row">
                        <div class="col-4">
                            <img class="img-fluid" src="{{URL}}{{pub.urlimg}}" alt="">
                        </div>
                        <div class="col-8">
                            <div><strong>TEMA</strong>: </div>
                            <hr>
                            <div><strong>EQUIPO TÉCNICO</strong>: {{pub.team}}</div>
                            <hr>
                            <div><strong>PÁGINAS</strong>: {{pub.pages}} p.</div>
                            <hr>
                            <div><strong>EDITORIAL</strong>: {{pub.editorial}}</div>
                            <hr>
                            <div><strong>FECHA</strong>: {{pub.year}}</div>
                            <hr *ngIf="pub.appointment">
                            <div *ngIf="pub.appointment"><strong>CÓMO CITAR</strong>: {{pub.appointment}}</div>
                            <br>
                            <div class="text-right">
                                <a class="a-download-pub" href="{{pub.urlfile}}"><i class="fa fa-download "></i>
                                    DESCARGAR</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="row">
                    <div class="col-12 div-icons-pub">
                        <div class="left"><i class="fa fa-share-alt"></i> Compartir</div>
                        <div class="right">
                            <div class="div-icon-pub" href="#"> <i class="fa fa-whatsapp"> </i></div>
                            <div class="div-icon-pub">
                                <a class="a-icon-pub" href="https://pe.linkedin.com/company/ceplan"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                            <div class="div-icon-pub" href="#"> <i class="fa fa-link"> </i></div>
                        </div>
                    </div>
                    <!-- <hr> -->
                    <div class="col-12 pub-container mb-3">
                        <div class="subtitle-pub">
                            <div><i class="fa fa-search center"></i>Buscar</div>
                        </div>
                        <input class="input-search-pub mb-3" type="text" placeholder="Buscar en el repositorio">
                        <div class="recent-pubs"><a class="underline" routerLink="../../filtro/fecha/recientes">Ver publicaciones
                                recientes <i class="fa fa-chevron-right"></i></a></div>
                    </div>
                    <div>
                        <div class="subtitle-pub">Temáticas</div>
                        <div class="col-md-12 list-tem">
                            <ng-container *ngFor="let t of tematic">
                                <a class="a-tematic-pub" [style.border-color]="t.color"
                                    routerLink="../../filtro/tematica/{{t.id}}">{{t.title}}</a>
                            </ng-container>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="subtitle-pub">Descripción</div>
                <div class="contents-pub" [innerHTML]="pub.description"></div>
                <div *ngIf="pub.description">
                    <br><b>Contenido</b>
                </div>
                <div class="contents-pub" [innerHTML]="pub.contents"></div>
            </div>
        </div>

    </ng-container>

</div>